module.exports = __webpack_public_path__ + "files/75618042fd6d0025f3947b0f0d8f85e2.png";